<form class="form">

  <hs-symbolizer-color-picker [symbolizer]="symbolizer" attribute="color" opacityAttribute="opacity"
    [class.disabled]="symbolizer.graphicFill !== undefined" (changes)="opacityFix(); emitChange()"
    [label]="'STYLER.fillColor' | translateHs">
    <span class="badge bg-warning mt-2" *ngIf="symbolizer.graphicFill !== undefined"
      [title]="'STYLER.warningFillNotVisualizedDueToGraphic' | translateHs  ">!</span>
  </hs-symbolizer-color-picker>

  <hs-symbolizer-slider [symbolizer]="symbolizer" attribute="opacity" (changes)="opacityFix(); emitChange()" step="0.05"
    min="0" max="1" [label]="'STYLER.opacity' | translateHs "></hs-symbolizer-slider>

  <hs-symbolizer-color-picker [symbolizer]="symbolizer" attribute="outlineColor" opacityAttribute="outlineOpacity"
    (changes)="emitChange()" [label]="'STYLER.outlineColor' | translateHs ">
  </hs-symbolizer-color-picker>

  <hs-symbolizer-slider [symbolizer]="symbolizer" attribute="outlineOpacity" (changes)="emitChange()" step="0.05"
    min="0" max="1" [label]="'STYLER.outlineOpacity' | translateHs "></hs-symbolizer-slider>

  <hs-symbolizer-slider [symbolizer]="symbolizer" attribute="outlineWidth" (changes)="emitChange()" step="0.1" min="0"
    max="20" [label]="'STYLER.outlineWidth' | translateHs  "></hs-symbolizer-slider>

  <div class="d-flex flex-row justify-content-end">
    <div class="p-1 flex-grow-1">{{'STYLER.graphicFill' | translateHs}}:</div>
    <div class="p-1">
      <div class="btn-group">
        <div ngbDropdown class="btn-group d-inline-block" role="group" #graphicFillMenu="ngbDropdown"
          placement="top-right">
          <button class="btn btn-outline-primary btn-sm" id="dropdownAddFillSymbolizer" ngbDropdownToggle>
            <span class="icon-plus"></span>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownAddFillSymbolizer">
            <button ngbDropdownItem (click)="addSymbolizer('graphicFill', 'Mark'); graphicFillMenu.close()">
              {{'STYLER.mark' | translateHs }}
            </button>
            <button ngbDropdownItem (click)="addSymbolizer('graphicFill', 'Icon'); graphicFillMenu.close()">
              {{'STYLER.icon' | translateHs }}
            </button>
          </div>
        </div>
        <button class="btn btn-outline-danger btn-sm" *ngIf="symbolizer.graphicFill !== undefined"
          (click)="symbolizer.graphicFill = undefined;emitChange()">
          <span class="icon-trash"></span>
        </button>
      </div>
    </div>
  </div>

  <hs-mark-symbolizer [symbolizer]="symbolizer.graphicFill" [submenu]="true" (changes)="emitChange()"
    *ngIf="symbolizer.graphicFill && symbolizer.graphicFill.kind === kinds.mark">
  </hs-mark-symbolizer>

  <hs-icon-symbolizer [symbolizer]="symbolizer.graphicFill" [submenu]="true" (changes)="emitChange()"
    *ngIf="symbolizer.graphicFill && symbolizer.graphicFill.kind === kinds.icon">
  </hs-icon-symbolizer>
</form>